<template>
    <div class="card-body">
        <div class="row text-left mb-3">
            <div class="col-sm-12 mb-2">
                <p class="h4"><button @click="goBack()" class="btn btn-link mr-2"><i class="fa fa-arrow-left"></i> {{ __('payments.Go back') }}</button> {{ __('payments.Follow steps') }}</p>
            </div>
        </div>

        <div>
            <Paypal v-if="method == 'paypal'" :plan="plan"></Paypal>
            <Wirecard v-if="method == 'wirecard'" :plan="plan"></Wirecard>
            <Neteller v-if="method == 'neteller'" :plans="plans"></Neteller>
            <Skrill v-if="method == 'skrill'" :plans="plans"></Skrill>
        </div>
    </div>
</template>

<script>
import Paypal from './Methods/Paypal';
import Neteller from './Methods/Neteller';
import Skrill from './Methods/Skrill';
import Wirecard from './Methods/Wirecard';
export default {
    props: ['method', 'plan', 'plans'],
    components: {
        Paypal,
        Neteller,
        Skrill,
        Wirecard
    },
    data() {
        return {};
    },
    methods: {
        goBack() {
            this.$emit('goBack');
        }
    }
}
</script>

<style>

</style>